<template>
  <div>
    <el-dialog :close-on-click-modal="false" title="激活名单" :visible.sync="visibleDialog" :before-close="closeDialog" width="640px">
      <img src="@/assets/call/icon-warning.png" alt="">
      <h2>确认将所选的名单激活?</h2>
      <p>本次选择 <span style="color: red;">{{dataLsit.length}}</span> 条已关闭名单，激活后将清空归属人，变为“待分配”状态</p>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button v-if="dataLsit.length" :loading="loading" size="small" type="primary" @click="activateLeads">确定激活</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { activateLeads } from '@/views/call/api'
export default {
  name: 'activateDialog',
  props: {
  },
  data() {
    return {
      dataLsit: [],
      loading: false,
      visibleDialog: false
    }
  },
  computed: {
  },
  directives: {
  },
  watch: {
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    activateLeads() {
      this.loading = true
      var leadIds = this.dataLsit.map(x => { return x.id })
      activateLeads({ leadIds: leadIds }).then(res => {
        this.loading = false
        if (res.code == '0') {
          this.$emit('getData')
          this.$emit('closeDrawer')
          this.visibleDialog = false
          this.$message.success('激活成功')
        }
      }).catch(_ => { this.loading = false })
    },
    openDialog(list) {
      this.dataLsit = []
      list.forEach(e => {
        if (e.leadState === 4) {
          this.dataLsit.push(e)
        }
      })
      this.visibleDialog = true
    },
    closeDialog() {
      this.visibleDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__body {
  text-align: center;
  color: #333;
  img {
    margin-top: 14px;
  }
  h2 {
    margin: 30px 0 10px 0;
    font-size: 16px;
    font-weight: 600;
  }
  p {
    font-size: 14px;
    margin-bottom: 14px;
  }
}
/deep/.el-dialog__header {
  .el-dialog__title {
    font-size: 16px;
    color: #333;
    font-weight: 600;
  }
}
</style>
